// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/grounds.detail.scss'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "customLists" */ './js/components/customLists.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// Grounds Map
async function getGroundsMap ($f) {
  import(/* webpackChunkName: "groundsMap", webpackPrefetch: true */ './js/components/groundsMap.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Responsive Tabs
async function getRTabs () {
  import(/* webpackChunkName: "responsiveTabs" */ './js/components/responsiveTabs.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Agencies Search Form
async function getAsForm ($f) {
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des scrollbars améliorées
  const $l = $('.custom-lists')
  if ($l.length) {
    $l.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // boutons d'action sur le terrain détaillé
  if (typeof (googleanalytics) !== 'undefined') {
    $('#track-f').on('click', () => { // event sur bouton financement : track event google analytics
      /* global ga */
      ga('send', 'event', 'Financement terrain', 'Clic')
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing', { element: 'ground' }) }
    })
    $('#track-c, #track-c2').on('click', () => { // event sur bouton contact : track event google analytics
      ga('send', 'event', 'Contacter terrain', 'Clic')
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { subject: 'ground' }) }
    })
    $('#track-m').on('click', () => { // event sur bouton modèle
      ga('send', 'event', 'Recherche modele', 'Clic')
      if (typeof (googletag) !== 'undefined') { gtag('event', 'find_model') }
    })
  }

  // wait until gmap is correctly loading
  dtectMap(function () {
    // gestion de la carte des terrains
    const $m = $('#map-grounds')
    if ($m.length) {
      $m.waypoint(function () {
        $m.load()
        getGroundsMap($m)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })

  // formulaire de contact
  const $f = $('form[name="cForm"]')
  $f.waypoint(function () {
    $f.load()
    getCForm($f)
    this.destroy()
  }, {
    offset: '100%'
  })

  // responsive tabs
  $('#desc-tabs').waypoint(function () {
    getRTabs()
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion de la recherche d'agences la plus proche
  const $c = $('form[name="asForm"]')
  if ($c.length) {
    $c.waypoint(function () {
      $c.load()
      getAsForm($c)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })
})
